module.exports = __webpack_public_path__ + "static/media/george-nees.f947f457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/george-nees.jpg
// module id = 424
// module chunks = 13